export default "__VITE_ASSET__CKsxL8nP__"